import { PromotionDetail } from './PromotionDetail'
import { withPromotionDetail } from './withPromotionDetail'

const ConnectedPromotionDetail = withPromotionDetail(PromotionDetail)

export { ConnectedPromotionDetail as PromotionDetail }
